import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MyDocumentComponent } from './my-document/my-document.component';
import { SendDocumentComponent } from './send-document/send-document.component';

const routes: Routes = [
  { path: 'my-document', component: MyDocumentComponent },
  { path: 'send-document', component: SendDocumentComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ESignRoutingModule { }
